var React = require('react');

function WebDevelopment (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#00E3CC","d":"M53 23h17v19H53z","key":0}),React.createElement("g",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},[React.createElement("path",{"d":"M68.598 15.538H54.186c-1.326 0-2.402 1.096-2.402 2.447v31.8c0 1.35 1.076 2.446 2.402 2.446h14.412c1.326 0 2.402-1.096 2.402-2.446v-31.8c0-1.35-1.076-2.447-2.402-2.447zM51.784 21.77H71M51.784 43.23H71","key":0}),React.createElement("path",{"d":"M64.137 15.416V7.334c0-3.499-2.865-6.334-6.4-6.334H7.4C3.865 1 1 3.835 1 7.334v28.179c0 3.498 2.865 6.333 6.401 6.333h44.594M31.882 41.154V52.23M1 31.462h50.784M18.843 52.23h25.392","key":1})])]));
}

WebDevelopment.defaultProps = {"width":"72","height":"54","viewBox":"0 0 72 54"};

module.exports = WebDevelopment;

WebDevelopment.default = WebDevelopment;
